module.exports = __webpack_public_path__ + "media/images/calendar_today-24px-3bc55cf936f754532c7a1a331aa6ce81.svg";